import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';
import { Link } from 'react-router-dom';
import { useBillingOverview } from '@/hooks/useBilling';
import { SubscriptionStatus } from '@/types/enums';

const DAY_MS = 86_400_000;

export function PlanBadge() {
  const { data } = useBillingOverview();
  const subscription = data?.subscription;

  if (!subscription?.billingEnabled) return null;

  if (subscription.status === SubscriptionStatus.TRIALING) {
    const endsAt = subscription.trialEndsAt ?? subscription.currentPeriodEnd;
    if (endsAt == null) return null;

    const daysLeft = Math.max(0, Math.ceil((endsAt - Date.now()) / DAY_MS));
    const urgent = daysLeft <= 3;

    return (
      <Link to="/app/billing">
        <Tooltip title="Choose a plan before your trial ends">
          <Badge
            variant={urgent ? 'warning' : 'secondary'}
            className="cursor-pointer whitespace-nowrap"
          >
            {daysLeft === 0
              ? 'Trial ends today'
              : `Trial · ${daysLeft} day${daysLeft === 1 ? '' : 's'} left`}
          </Badge>
        </Tooltip>
      </Link>
    );
  }

  if (subscription.status === SubscriptionStatus.PAST_DUE) {
    return (
      <Link to="/app/billing">
        <Tooltip title="Nothing has stopped working yet — update your card and we will retry">
          <Badge variant="warning" className="cursor-pointer">
            Payment failed
          </Badge>
        </Tooltip>
      </Link>
    );
  }

  if (!subscription.entitled) {
    return (
      <Link to="/app/billing">
        <Button size="sm" variant="default" className="text-xs h-7 px-2.5">
          Choose a plan
        </Button>
      </Link>
    );
  }

  return null;
}
